import { DatabaseObject } from "./class";

export class Role extends DatabaseObject {
  static $route = "role";

  name: string = "";
}

export class PlannerGroup extends DatabaseObject {
  static $route = "planner-group";

  code: string = "";
  name: string = "";
}

export class CostCenter extends DatabaseObject {
  static $route = "cost-center";

  code: string = "";
  name: string = "";
}

export class AssetClass extends DatabaseObject {
  static $route = "asset-class";

  name: string = "";
}
